/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyC9hzlHhVmSoNkJThJUFtbl_D483a2EEQ0",
    authDomain: "mymech-fc9fe.firebaseapp.com",
    databaseURL: "https://mymech-fc9fe.firebaseio.com",
    projectId: "mymech-fc9fe",
    storageBucket: "mymech-fc9fe.appspot.com",
    messagingSenderId: "494270760005",
    appId: "1:494270760005:web:29ca7d422463351ef68f2c",
    measurementId: "G-BNNFZ11SX0"
  }
};
